module.exports = __webpack_public_path__ + "media/login-bg-resized.2a3161ad.mp4";